type Props = {
  gracePeriodInMonths: number;
};

export const GracePeriodBadge = ({ gracePeriodInMonths }: Props) => {
  return (
    <span
      className="ml-1.5 flex items-center justify-center rounded-full bg-[#b0f558] px-2 py-0.5 text-center text-xs font-normal leading-4"
      data-qa-type="grace-period-badge"
    >
      Zero&nbsp;Plan: {gracePeriodInMonths}&nbsp;periods
    </span>
  );
};
